export const SET_TMP_BUFFER = 'SET_TMP_BUFFER';
export const SET_LIST_FILTER_VALUES = 'SET_LIST_FILTER_VALUES';

export default {
    [SET_TMP_BUFFER]: (state, payload) => {
        state.tmpBuffer = payload;
    },
    [SET_LIST_FILTER_VALUES]: (state, payload) => {
        state.list.filterValues = payload;
    },
};
